import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarlic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGarlic"><Path d="M14.5 21.1662C20 22.2257 21.25 18.307 21.25 15.5101C20.8207 9.71807 13.4605 7.7973 12.9737 2L10.0526 3.05405C10.9722 8.92763 2.75 9.95395 2.75 16.4676C2.75 20.4132 6.15709 22.2 9.28628 21.0553M13.4605 10.9595C14.4342 13.0676 16.2052 19.8102 13.9015 21.0143C12.6879 21.6487 10.8561 21.7187 9.71091 20.8814C8.16439 19.7459 8.59211 14.6486 9.56579 12.5405" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGarlic;
